require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-center-first-cu-meets-with-credit-union-in-ireland-to-discuss.json") })
        }
      }, "path---es-articles-financial-center-first-cu-meets-with-credit-union-in-ireland-to-discuss");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-center-first-cu-meets-with-credit-union-in-ireland-to-discuss!./.cache/json/es-articles-financial-center-first-cu-meets-with-credit-union-in-ireland-to-discuss.json
// module id = 2132
// module chunks = 231608221292675